import { render, staticRenderFns } from "./application-container.vue?vue&type=template&id=a3df90e4&scoped=true"
import script from "./application-container.vue?vue&type=script&lang=ts"
export * from "./application-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3df90e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3df90e4')) {
      api.createRecord('a3df90e4', component.options)
    } else {
      api.reload('a3df90e4', component.options)
    }
    module.hot.accept("./application-container.vue?vue&type=template&id=a3df90e4&scoped=true", function () {
      api.rerender('a3df90e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application/components/application-container.vue"
export default component.exports